import * as React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";

// Stops the mouse wheel from changing a NumericTextBox value.
export const useDisableNumericWheel = () => {
  const ref = React.useRef(null);

  React.useEffect(() => {
    const element = ref.current?.element;
    if (!element) return;

    const handleWheel = (event) => event.stopPropagation();
    element.addEventListener("wheel", handleWheel);

    return () => element.removeEventListener("wheel", handleWheel);
  }, []);

  return ref;
};

export const NumericCell = (props) => {
  const numericRef = useDisableNumericWheel();

  return (
    <td className="right-align-full numeric-input-padding">
      <NumericTextBox
        ref={numericRef}
        format={props.format || "n2"}
        className="mt-auto"
        min={props.min}
        max={props.max}
        value={
          props.dataItem.amount !== undefined
            ? props.dataItem.amount
            : props.dataItem.value
        }
        onChange={(e) => {
          if (props.onChange) {
            props.onChange({
              dataIndex: 0,
              dataItem: props.dataItem,
              field: props.field,
              syntheticEvent: e.syntheticEvent,
              value: e.value,
              counter: props.dataItem.counter,
            });
          }
        }}
        spinners={false}
      />
    </td>
  );
};
